import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { GestaoDeCteComponent } from '../gestao-de-cte.component';
import { CTEModel } from '../gestao-de-cte.model';

@Component({
  selector: 'app-gestao-de-cte-grid-pesquisa',
  templateUrl: './gestao-de-cte-grid-pesquisa.component.html',
  styleUrls: ['./gestao-de-cte-grid-pesquisa.component.scss']
})
export class GestaoDeCTEGridPesquisaComponent implements OnInit {
  public grid: MatTableDataSource<CTEModel> = new MatTableDataSource<CTEModel>();
  @Input() parent: GestaoDeCteComponent;
  @Input() gridData;

  isLoadingDownload: boolean = false;

  get exibirGrid() { return this.parent.exibirGrid; }
  set exibirGrid(value) { this.parent.exibirGrid = value; }

  get isLoading() { return this.parent.isLoading; }
  set isLoading(value) { this.parent.isLoading = value; }

  get paging() { return this.parent.paging; }
  set paging(value) { this.parent.paging = value; }

  constructor(public dialog: MatDialog) {
    this.grid.data = this.gridData;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.grid.data = changes['gridData']?.currentValue;
  }

  public displayedColumns: string[] =
    [
      //"action",
      //"id",
      "filialEmissaoDescricao",
      "numCTE",
      "produto",
      "chaveCTE",
      "dtEmissao",
      "qtdeNRT",
      "qtdeNF",
      "tomador",
      "pid",
      "cepDestino",
      "lote",
      "peso",
      "tipoCteDescricao",
      // "tipoFaturamentoDescricao",
      "tipoProcessamentoDescricao",
      "tipoStatusCancelamentoDescricao",
      "flagCteAgrupado",
      "valorFrete",
      "adValorem",
      "gris",
      "imposto",
      "totalFrete",
      "statusDescricao"
    ];
  limparPesquisa() {
    this.grid.data = null;
    this.exibirGrid = false;
    this.isLoading = false;
  }

  ngOnInit() {

  }

  download() {
    this.isLoadingDownload = true;
    this.parent.excel()
      .add(() => (this.isLoadingDownload = false));
  }

  public arredondar(p) {
    return Math.round(p);
  }


}
